export default "__VITE_ASSET__ZMeNERqs__"